import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['combineOption',
    'seperateGratuityServiceChargeOption',
    'combinedGratuityAndServiceCharge',
    'seperateGratuityAndServiceCharge',
    'form'
  ];

  connect() {
    this.seperateGratuityServiceChargeOptionTargets.forEach(option => {
      if (option.checked === true && option.value === 'false') {
        this.showCombineGratuityAndServiceChargeLabels();
      }

      if (option.checked === true && option.value === 'true') {
        this.showSeparateGratuityAndServiceChargeLabels();
      }
    });
  }

  toggleCombineGratuityAndServiceChargeOption(event) {
    this.seperateGratuityServiceChargeOptionTargets.forEach(option => {
      option.checked = false;
    });
    event.currentTarget.checked = true;
    if (event.currentTarget.value === 'false') {
      this.showCombineGratuityAndServiceChargeLabels();
    } else {
      this.showSeparateGratuityAndServiceChargeLabels();
    }
  }

  showCombineGratuityAndServiceChargeLabels() {
    this.seperateGratuityAndServiceChargeTarget.classList.add('hidden');
    this.combinedGratuityAndServiceChargeTarget.classList.remove('hidden');
  }

  showSeparateGratuityAndServiceChargeLabels() {
    this.seperateGratuityAndServiceChargeTarget.classList.remove('hidden');
    this.combinedGratuityAndServiceChargeTarget.classList.add('hidden');
  }

  submitForm(event) {
    event.preventDefault()
    this.seperateGratuityServiceChargeOptionTargets.forEach(option => {
      option.remove()
    })
    this.formTarget.submit()
  }
}
